import React from "react";
import Draggable from "react-draggable";
import Paper, { PaperProps } from "@mui/material/Paper";

export function DraggableDialogPaper(props: PaperProps) {
    const nodeRef = React.useRef<HTMLDivElement>(null);

    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}